var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#751A46",
    d: "M24 .035H.105v15.93H24V.035z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M9.818 3.268L7.463 4.453 9.818 5.63 7.463 6.815 9.818 8 7.463 9.185l2.355 1.185-2.355 1.185 2.355 1.185-2.355 1.185 2.355 1.185-1.71.855H0V.035h8.107l1.71.863-2.354 1.185 2.355 1.185z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQatar);
export default __webpack_public_path__ + "static/media/Qatar.600ad2f8639c9e748e036698da7a9a06.svg";
export { ForwardRef as ReactComponent };